import { component } from 'picoapp';
import { animate, timeline } from 'motion';


class Collapsible {
  constructor(el, ctx) {
    this.isActive = false;
    this.ctx = ctx;
    this.identifier = el.dataset.identifier || el.id;
    this.toggle = this.toggle.bind(this);
    this.init(el);
  }

  init(el) {
    this.el = el;
    // cache elements
    this.content = el.querySelector('.collapsible__container');
    this.triggers = document.querySelectorAll(`[aria-controls="${this.identifier}"]`)
    this.el.style.setProperty('--collapsible-element-height', `${this.content.offsetHeight}px`);
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', ev => {
        this.toggle()
      })
    })
    window.addEventListener('resize', () => {
      this.el.style.setProperty('--collapsible-element-height', `${this.content.offsetHeight}px`);
    });
    this.ctx.on('Collapsible', state => {
      if (this.identifier != state.identifier && state.action == "open" && this.isActive) {
        this.toggle()
      }
    })
  }

  toggle() {

    // Bailout if toggle component is disabled
    if (this.disabled) {
      return;
    }
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }

    //Updates triggers ARIA attributes
    this.triggers.forEach(trigger => {
      this.isActive ? trigger.setAttribute('aria-expanded', false) : trigger.setAttribute('aria-expanded', true)
    })
  }

  open() {
    if (this.isActive) {
      return;
    }
    this.ctx.emit('Collapsible', { identifier: this.identifier, action: 'open' })

    animate(this.el, { visibility: 'visible' });

    let sequence = [
      [this.el, { opacity: [0, 1], height: [0, "var(--collapsible-element-height)"] }, { duration: 0.3 }]
    ];
    timeline(sequence).finished.then(() => {
      this.isActive = true;
      this.el.focus()

    });
  }

  close() {
    if (!this.isActive) {
      return;
    }
    let sequence = [
      [this.el, { opacity: [1, 0], height: ["var(--collapsible-element-height)", 0] }, { duration: 0.25, at: '-0.2' }]


    ];
    timeline(sequence).finished.then(() => {
      animate(this.el, { visibility: 'hidden' });
      this.isActive = false;
      this.el.blur()
    });
  }
}

export default component((node, ctx) => {
  new Collapsible(node, ctx);
});
